export default __webpack_public_path__ + "static/media/phppgadmin-negative.48f91933.svg";